import React, { Component } from 'react';

import { LoginBeWise } from '../../API/FetchCall';

import Cookies from 'universal-cookie';
import Recaptcha from 'react-recaptcha';
import { GOOGLE_CAPTCHA_SITE_KEY } from '../../constant.js';

class LoginV2 extends Component {
    constructor(props) {
        const cookies = new Cookies();
        super(props);
        this.state = {
            email_id: '',
            password: '',
            otp: '',
            verify_otp: true,
            auth_data: '',
            user_id: '',
            logged:false,
            phone_number: '',
            isVerified: false,
            showPassword: false,
            disabled: true,
            role:"",
            otp_check: cookies.get('otpVerified') ? cookies.get('otpVerified') : false,
        }
        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
    }

    recaptchaLoaded = (e) => {
       console.log('Successfully loaded');
    }
    verifyCallback = (response) => {
        if (response) {
            this.setState({
                isVerified: true,
                disabled: false
            });
        }

    }
    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
    handleChangeOtp = (e) => {
        this.setState({ [e.target.name]: e.target.value.slice(0, e.target.maxLength) });
    };   

    handleSubmitLogin = (e) => {
        e.preventDefault();
        
        let ins = JSON.stringify({
            email_id: this.state.email_id,
            password: this.state.password
        });
        LoginBeWise(ins).then((res) => {
            if (res.status === 1) {
               
                console.log(JSON.stringify(res.auth_data));

                localStorage.setItem('user_data', JSON.stringify(res.auth_data));
                localStorage.setItem('access', JSON.stringify(res.auth_data.access));

                localStorage.setItem('organisation', JSON.stringify(res.auth_data.organisation));
                localStorage.setItem('organisation_place', JSON.stringify(res.auth_data.organisation_place));

                localStorage.setItem('is_completed', (res.auth_data.is_completd));
                localStorage.setItem('is_active', (res.auth_data.is_active));
                localStorage.setItem('show_pop', (res.auth_data.current_plan === 0 ? true : false));
                localStorage.setItem('authentication', true);
                this.setState({logged:true, nouser:false, role:(res.auth_data.role===1)?"Administrator":(res.auth_data.role===3)?"Partner":"BeWise Team"});

                if(res.auth_data.role===3){

                    setTimeout(function () {
                        window.location.replace("/partner/dashboard");
                    }, 1000);

                }
                else if(res.auth_data.role===11){

                  setTimeout(function () {
                      window.location.replace("/exclusiveparnter/dashboard");
                  }, 1000);

                }else{
                    setTimeout(function () {
                            window.location.replace("/dashboard/dashboard");
                    }, 1000);
                }


                

            } else {
                let error_mgs = res.msg;
                this.setState({nouser:true, msg:error_mgs});  
            }

        });
    };    

    componentDidMount() {
        let logged = localStorage.getItem("authentication");
        let auth_data = JSON.parse(localStorage.getItem("user_data"));
        console.log('auth_data.role', logged);
         
        if (logged === 'true' && auth_data !== 'null' && auth_data.role === 1) {
          window.location.href = '/dashboard/dashboard';
        } else if (logged === 'true' && auth_data !== 'null' && auth_data.role === 3) {
          window.location.href = '/partner/profile';
        }
        

    }     

    render() {

        return (
               <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
              <div class="brand-logo">
                <img src="../../images/bewiseLogo.png" alt="BeWise Logo" />
              </div>
              <h4>Hello! let's get started</h4>
              <h6 class="font-weight-light">Sign in to continue.</h6>
              <form class="pt-3" onSubmit={this.handleSubmitLogin} autoComplete='off' className="login-form" action="#">
                <div class="form-group">
                  <input type="email" name="email_id" class="form-control form-control-lg" id="email_id" placeholder="Email Id" onChange={this.handleChange} />
                </div>
                <div class="form-group">
                  <input type="password" name="password" class="form-control form-control-lg" id="password" placeholder="Password" onChange={this.handleChange} />
                </div>
                <div class="form-group">
                    <Recaptcha
                        sitekey={GOOGLE_CAPTCHA_SITE_KEY}
                        render="explicit"
                        onloadCallback={this.recaptchaLoaded}
                        verifyCallback={this.verifyCallback}
                    />
                </div>
                {!this.state.nouser && this.state.logged &&
                <div class="alert alert-success" role="alert">
                        Successful. You are logged in as {this.state.role}
                </div>
                }
                {this.state.nouser && 
                <div class="alert alert-danger" role="alert">
                       {this.state.msg}
                </div>
                }
                <div class="mt-3">
                  <button type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn" >SIGN IN</button>
                </div>
                <div class="my-2 d-flex justify-content-between align-items-center">
                  <div class="form-check">
                     
                  </div>
                  <a href="/forgot_excl" class="auth-link text-black">Forgot password?</a>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>


        )
    }
}


export default LoginV2;


// WEBPACK FOOTER //
// ./src/components/bewise/loginexcl.jsx